import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const useMarkSupportReadMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (conversationId) => {
      const token = localStorage.getItem("token");
      const { data } = await axios.post(
        `${__API_URL__}/api/support/admin/conversations/${conversationId}/mark-read/`,
        {},
        { headers: { Authorization: `Token ${token}` } }
      );
      return data;
    },
    onSuccess: (_, conversationId) => {
      queryClient.invalidateQueries({ queryKey: ["support_conversations"] });
      queryClient.invalidateQueries({ queryKey: ["support_conversation_detail", conversationId] });
      queryClient.invalidateQueries({ queryKey: ["support-unread-count"] });
    },
  });
};

export default useMarkSupportReadMutation;
